import {useEffect} from 'react';
import classNames from 'classnames';
import {RecordViewHomeOnLoad} from 'components/Analytics/RecordViewHomeOnLoad.client';
import {FAQ} from '../components/FAQ.client';
import {Footer} from '../components/Footer.client';
import {Header} from '../components/Header.client';
import {Hero} from '../components/Hero/Hero.client';
import {Metrics} from '../components/Metrics';
import {ProductFeatures} from '../components/ProductFeatures';
import {Monetize} from '../components/Monetize';
import {Reviews} from '../components/Reviews';
import {initGradientBackground} from 'utils/gradientBackground';
import {useI18n} from '../contexts/I18n.client';

import './Root.css';

export const RootClient = () => {
  const {language} = useI18n();

  useEffect(() => {
    initGradientBackground();
  }, []);

  return (
    <>
      <RecordViewHomeOnLoad />

      <div className={language === 'en' ? 'font-trap' : 'font-shopify'}>
        <Header />

        <Hero className="mb-36" />

        <Metrics className={classNames('mb-28', 'md:mb-40')} />

        <ProductFeatures className={classNames('mb-28', 'md:mb-40')} />

        <Monetize className={classNames('mb-28', 'md:mb-40')} />

        <Reviews className={classNames('mb-28', 'md:mb-40')} />

        <FAQ className="mb-10" />

        <Footer />
      </div>
    </>
  );
};
